import { render } from "./BaseFormFieldRefiRadio.vue?vue&type=template&id=63979b0e&scoped=true&ts=true"
import script from "./BaseFormFieldRefiRadio.vue?vue&type=script&lang=ts"
export * from "./BaseFormFieldRefiRadio.vue?vue&type=script&lang=ts"

import "./BaseFormFieldRefiRadio.vue?vue&type=style&index=0&id=63979b0e&lang=scss&scoped=true"

import exportComponent from "D:\\a\\1\\s\\src\\ApplicantPortal.Web\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63979b0e"]])

export default __exports__